import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useState } from "react";
import { Bell, Bookmark, Newspaper, ShieldCheck, UserRound } from "lucide-react";
import { useReader } from "../../context/ReaderContext";
import { BrandLoader } from "../../components/site/Logo";
import { ReaderPage, btnLine, btnMain } from "./ReaderShell";
import { ProfileWizard } from "./ProfileWizard";
import { track } from "../../lib/analytics";

const GuestSetup = () => {
  const { guest, setGuestProfile, resetGuest } = useReader();
  const [store, setStore] = useState(guest?.stored ?? false);
  const [edit, setEdit] = useState(!guest);
  const nav = useNavigate();
  const save = async (p) => {
    setGuestProfile(p, store);
    track(guest?.profile ? "personalization_changed" : "personalization_enabled");
    toast.success(store ? "Izbori su sačuvani u ovom pregledniku" : "Izbori vrijede dok je stranica otvorena");
    nav("/moje-vijesti");
  };
  return (
    <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_320px]">
      <div>
        {edit ? <ProfileWizard initial={guest?.profile} onSave={save} /> : (
          <div className="rounded-sm border border-border bg-card p-6" data-testid="guest-profile-summary">
            <p className="font-semibold">Tvoji izbori su aktivni{guest?.stored ? " i sačuvani u ovom pregledniku" : " samo dok je ova stranica otvorena"}.</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Link to="/moje-vijesti" className={btnMain} data-testid="guest-open-feed">Moje vijesti</Link>
              <button onClick={() => setEdit(true)} className={btnLine} data-testid="guest-edit">Promijeni izbore</button>
              <button onClick={() => { resetGuest(); setEdit(true); toast.success("Izbori su obrisani iz preglednika"); }} className={btnLine} data-testid="guest-reset">Obriši moje izbore</button>
            </div>
          </div>
        )}
      </div>
      <aside className="space-y-4 text-sm" data-testid="guest-privacy-info">
        <div className="rounded-sm border border-border bg-surface p-5">
          <h2 className="font-display text-lg font-semibold">Bez računa, bez profila na serveru</h2>
          <p className="mt-2 text-muted-foreground">Kao gost, tvoji izbori se ne spremaju na naš server. Šalju se samo uz zahtjev za listu vijesti i odmah zaboravljaju.</p>
          <label className="mt-4 flex gap-2"><input type="checkbox" checked={store} onChange={(e) => setStore(e.target.checked)} className="mt-1" data-testid="guest-store-consent" /><span>Zapamti izbore u ovom pregledniku (lokalna pohrana). Možeš ih obrisati u svakom trenutku.</span></label>
        </div>
        <div className="rounded-sm border border-border p-5">
          <p>Sa besplatnim računom dobijaš i sačuvane članke, obavještenja i iste postavke na svim uređajima.</p>
          <Link to="/registracija" className={`${btnLine} mt-3 w-full`} data-testid="guest-register-cta">Otvori račun</Link>
        </div>
      </aside>
    </div>
  );
};

const LINKS = [["/moje-vijesti", Newspaper, "Moje vijesti", "Vijesti poredane po tvojim interesovanjima"], ["/sacuvano", Bookmark, "Sačuvano", "Članci koje si sačuvao/la"], ["/obavjestenja", Bell, "Obavještenja", "Važne vijesti i pregledi u aplikaciji"], ["/moj-profil", UserRound, "Moj profil", "Interesovanja, boravak, pokrajina"], ["/postavke-privatnosti", ShieldCheck, "Privatnost", "Saglasnosti, izvoz i brisanje podataka"]];

const ReaderHome = () => {
  const { reader } = useReader();
  return (
    <>
      <p className="text-lg" data-testid="reader-welcome">Dobro došao/la{reader.display_name ? `, ${reader.display_name}` : ""}.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {LINKS.map(([to, Icon, t, d]) => (
          <Link key={to} to={to} className="group rounded-sm border border-border bg-card p-5 transition-colors hover:border-ink" data-testid={`hub-link-${to.slice(1)}`}>
            <Icon className="h-5 w-5 text-pulse" /><p className="mt-3 font-display text-lg font-semibold">{t}</p><p className="mt-1 text-sm text-muted-foreground">{d}</p>
          </Link>
        ))}
      </div>
    </>
  );
};

export default function MojBalkan() {
  const { reader } = useReader();
  if (reader === null) return <BrandLoader />;
  return (
    <ReaderPage title="MOJ BALKAN INFO" intro="Odaberi teme i podatke koji su ti važni i odmah vidi relevantne vijesti. Sva pitanja su opcionalna. Preporuke su informativne – nisu pravna procjena." testId="moj-balkan-page" tabs={!!reader}>
      {reader ? <ReaderHome /> : <GuestSetup />}
    </ReaderPage>
  );
}
